import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=5d79303a&scoped=true&"
import script from "./PersonalCenter.vue?vue&type=script&lang=js&"
export * from "./PersonalCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=5d79303a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79303a",
  null
  
)

export default component.exports